export const commonMetadata = {
  title: "RumbleDirect",
  description: "Uw partner voor innovatieve mobiliteitsmanagement software",
};
